/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Data } from '../contexts';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import MUIDataTable, { debounceSearchRender } from 'mui-datatables';
import { Resizable } from 'react-resizable';
import { ArrowUpward } from '@mui/icons-material';
import { ArrowDownward } from '@mui/icons-material';
import Tooltip from '@mui/material/Tooltip';
import DropdownFilter from '../../utils/DropdownFilter';
import LoaderGraphic from '../../utils/LoaderGraphic';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAnglesLeft } from "@fortawesome/free-solid-svg-icons";
import { CheckMark, XMark } from '../../utils/SVGIcons';
import IndustryDoctorsPNL from '../IndustryReport/IndustryDoctorsPNL';
import IndustryPDFandPrint from '../IndustryPDFandPrint';
import ExportDropdown from '../utils/ExportDropdown';
import DOMPurify from 'dompurify';
import TextEditor from '../TextEditor';
import TextEditorPDF from '../TextEditorPDF';
import nschbcCoverImage from '../../../../assets/images/nschbccoverimg26.png';

const startingPageNumber = 4;
const sanitizeOptions = {
  ALLOWED_TAGS: [
    'table',
    'thead',
    'tbody',
    'tfoot',
    'tr',
    'td',
    'th',
    'colgroup',
    'col',
    'h1','h2','h3','h4','h5','h6',
    'br','p','ul','ol','li','hr','div',
    'strong','em','u','s','a','span','mark'
  ],
  ALLOWED_ATTR: [
    'href', 'target', 'rel', 'style', 'dir', 'class', 'colspan', 'rowspan', 'colwidth', 'data-colwidth'
  ]
};
const debounce = (fn, delay) => {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
    };
};

// 621 NSCHBC
const NSCHBCReportContainer = (props) => {
    const reportRefs = useRef();
    const [displaySection, setDisplaySection] = useState('summary')
    const [naicsCodes, setNaicsCodes] = useState(props?.filter_options?.code || []);
    const [isLoading, setIsLoading] = useState(true);
    const [activeTab, setActiveTab] = useState(null);
    const [companyData, setCompanyData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [state, setState] = useState({
        fetch: !props?.calcs,
        filters: props?.filters || {},
        filterOptions: props?.filter_options || {},
        calcs: props?.calcs?.table || {},
        meta: props?.calcs?.meta || {},
        year: props?.filters?.year || '2024',
    })
    const [PDFPrintModalOpen, setPDFPrintModalOpen] = useState(false);
    const [displayPages, setDisplayPages] = useState([
        {
            title: 'Cover Page',
            checked: true,
            pageNumber: 1
        },
        {
            title: 'Table of Contents',
            checked: true,
            pageNumber: 2
        },
        {
            title: 'Introduction',
            checked: true,
            pageNumber: 3
        }
    ])
    const [filtersModalIsOpen, setFiltersModalIsOpen] = useState(false)
    const [activePopover, setActivePopover] = useState(null);
    const [tableOfContentNotes, setTableOfContentNotes] = useState(props.table_note || { id: null, page: 'nschbc-reports', title: 'Table of Contents', notes: '' });
    const [introNotes, setIntroNotes] = useState(props.intro_note || { id: null, page: 'nschbc-reports', title: 'Introduction', notes: '' });
    const [companyNumberView, setCompanyNumberView] = useState(10);
    const [filteredData, setFilteredData] = useState([]);
    const [aSortOrder, setASortOrder] = useState({ name: 'firm', direction: 'asc' });
    const [uSortOrder, setUSortOrder] = useState({ name: 'firm', direction: 'asc' });
    const [columnWidths, setColumnWidths] = useState({
        firm: 268,
        name: 127,
        naics: 131,
        naics_description: 173,
        data_through_year: 100,
        qualified: 100,
        fte_survey_completed: 100,
        owners: 100,
        number_of_associates: 77,
        hygienists_or_nurses: 140,
        number_of_assistants: 70,
        number_of_office_employees: 105,
    });

    const [userColumnWidths, setUserColumnWidths] = useState({
        firm: 365,
        first_name: 365,
        last_name: 365,
        email: 365,
    });

    useEffect(() => {
        const naicsCodes = props.filter_options.code.filter(codeDetails => codeDetails[0].length >= 6)
        if (!activeTab) {
            setActiveTab(naicsCodes[0][0])
        }
        setNaicsCodes(naicsCodes);
    
        setDisplayPages((prevState => {
            const dataAvailable = Object.keys(state.calcs)
            let pdfData = []
            let pageNum = startingPageNumber;
            naicsCodes.forEach((codeDetails, i) => {
                if (dataAvailable.includes(codeDetails[0]) && state.calcs[codeDetails[0]]['number_of_companies'] >= companyNumberView) {
                    pdfData.push({
                        title: codeDetails[0],
                        checked: true,
                        pageNumber: pageNum
                    })
                    pageNum += 1
                }
            })
            return [ ...prevState, ...pdfData ]
        }))
        if (state.fetch) {
            handleFilterSubmit(null, null)
        }
    }, [])

    const tbLabel = `${state.filters.year} TB?`;
    const fteLabel = `${state.filters.year} FTE?`;

    const calculateNSCHBCEmployeeAggData = async (e) => {
        e.preventDefault();
        const response = await fetch('/calculate_nschbc_employee_aggregate');

        if (!response.ok) {
            throw new Error('Network response was not ok');
        } else {
            alert('Running Agg Calcs on NSCHBC companies with Employee Data in Sidekiq!')
        }
    }

    const handleFilterSubmit = async (e, filters) => {
        if (e) { e.preventDefault(); }
        setIsLoading(true);
        let revenueBand = filters && filters.hasOwnProperty('revenue_band') ? filters.revenue_band : '';
        let region = filters && filters.hasOwnProperty('region') ? filters.region : '';
        let year = filters && filters.hasOwnProperty('year') ? filters.year : '';
        let dataset = filters && filters.hasOwnProperty('dataset') ? filters.dataset : '';
    
        try {
            const calculations = await fetch(`/nschbc_calcs?dataset=${dataset}&revenue_band=${revenueBand}&region=${region}&year=${year}`, {
                headers: {
                'X-CSRF-Token': window.token
                }
            });
            const calcsRes = await calculations.json();
            setState(prevState => {
                return {
                ...prevState,
                filters: calcsRes.filters,
                calcs: calcsRes.calcs.table,
                meta: calcsRes.calcs.table.meta,
                year: calcsRes.filters.year,
                }
            });

            setCompanyData(prevState => {
                return calcsRes.company_data
            })

            setFilteredData(prevState => {
                return calcsRes.company_data
            })

            setUserData(prevState => {
                return calcsRes.users
            })

            setDisplayPages((prevState => {
                const startingPages = [
                    {
                        title: 'Cover Page',
                        checked: true,
                        pageNumber: 1
                    },
                    {
                        title: 'Table of Contents',
                        checked: true,
                        pageNumber: 2
                    },
                    {
                        title: 'Introduction',
                        checked: true,
                        pageNumber: 3
                    }
                ]
                const dataAvailable = Object.keys(calcsRes.calcs.table)
                let pdfData = []
                let pageNum = startingPageNumber;

                naicsCodes.forEach((codeDetails, i) => {
                    if (dataAvailable.includes(codeDetails[0]) && calcsRes.calcs.table[codeDetails[0]]['number_of_companies'] >= companyNumberView) {
                        pdfData.push({
                            title: codeDetails[0],
                            checked: true,
                            pageNumber: pageNum
                        })
                        pageNum += 1
                    }
                })
                return [ ...startingPages, ...pdfData ]
            }))
            setIsLoading(false)
        } catch (error) {
            alert('Sorry something went wrong. Please try again later.')
            setIsLoading(false)
        }
    }

    const updateCompanyNotes = async (cleanHTML, type) => {
        let update = false
        if (type === 'intro') {
            update = introNotes.notes !== cleanHTML
        } else {
            update = tableOfContentNotes.notes !== cleanHTML
        }
        if (update) {
            const noteInfo = type === 'intro' ? introNotes : tableOfContentNotes

            try {
                const res = await fetch(`/api/v1/user_notes/${noteInfo.id}`, {
                    method: 'PATCH',
                    headers: {
                        'X-CSRF-Token': window.token,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        user_note: {
                            page: noteInfo.page,
                            title: noteInfo.title,
                            notes: cleanHTML,
                        }
                    }),
                })
    
                if (type === 'intro') {
                    setIntroNotes(prevState => {
                        return {
                            ...prevState,
                            notes: cleanHTML
                        }
                    })
                } else {
                    setTableOfContentNotes(prevState => {
                        return {
                            ...prevState,
                            notes: cleanHTML
                        }
                    })
                }
    
                if (!res.ok) {
                    throw new Error('Network response was not ok. Could not save note changes.');
                }
            } catch (e) {
                console.log(e)
            }
        }
    }

    const createUserNotes = async (cleanHTML, type) => {
        const noteInfo = type === 'intro' ? introNotes : tableOfContentNotes
        try {
            const res = await fetch(`/api/v1/user_notes`, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': window.token,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_note: {
                        page: noteInfo.page,
                        title: noteInfo.title,
                        notes: cleanHTML,
                    }
                }),
            })

            const resJson = await res.json()

            if (!res.ok) {
                throw new Error('Network response was not ok. Could not save note changes.');
            } else {
                let notesRes = resJson.notes ? resJson.notes : cleanHTML

                if (type === 'intro') {
                    setIntroNotes(prevState => { return { ...prevState, notes: notesRes, id: resJson.id } })
                } else {
                    setTableOfContentNotes(prevState => { return { ...prevState, notes: notesRes, id: resJson.id } })
                }
            }
        } catch (e) {
            console.log(e)
        }
    }

    const onChangeTableNotes = useCallback(
        () => debounce((value) => {
            const cleanHTML = DOMPurify.sanitize(value, sanitizeOptions);

            if (tableOfContentNotes.id) {
                updateCompanyNotes(cleanHTML, 'table')
            } else {
                // Happens on page load?
                createUserNotes(cleanHTML, 'table')
            }
        }, 2000),
        [tableOfContentNotes.id]
    );

    const onChangeIntroNotes = useCallback(
        () => debounce((value) => {
            const cleanHTML = DOMPurify.sanitize(value, sanitizeOptions);

            if (introNotes.id) {
                updateCompanyNotes(cleanHTML, 'intro')
            } else {
                // Happens on page load?
                createUserNotes(cleanHTML, 'intro')
            }
        }, 2000),
        [introNotes.id]
    );

    const handlePDFandPrintChecked = (key) => {
        setDisplayPages((prevState) => {
            let newPages = _.cloneDeep(prevState)
            const dataAvailable = Object.keys(state.calcs)
            let pageNum = 4;

            return newPages.map(p => {
                if (p.title === key) {
                    p.checked = !p.checked
                }

                if (p.title !== 'Cover Page' && p.title !== 'Table of Contents' && p.title !== 'Introduction') {
                    if (p.checked) {
                        p.pageNumber = pageNum
                        pageNum += 1
                    } else {
                        p.pageNumber = 0
                    }
                }
                return p
            })

            return newPages
        })
    }

    const handleMouseEnter = (item) => {
        setActivePopover(item);
    };

    const handleMouseLeave = (item) => {
        if (item === 'leave') {
            setActivePopover(null);
        }
    };

    const openFiltersModal = () => {
        setFiltersModalIsOpen(true)
    }

    const closeFiltersModal = () => {
        setFiltersModalIsOpen(false)
    }

    const handleActiveTab = (section) => {
        setActiveTab(section)
        return;
    }

    const buildDocPNLs = () => {
        const naicsCodes = props.filter_options.code.filter(codeDetails => codeDetails[0].length >= 6)
        const dataAvailable = Object.keys(state.calcs)

        return naicsCodes.map(codeDetails => {
            if (dataAvailable.includes(codeDetails[0]) && state.calcs[codeDetails[0]]['number_of_companies'] >= companyNumberView) {
                let page = displayPages.find(p => p.title === codeDetails[0]);
                let pageNumber = page['pageNumber']
                let cssClass = ''
                if (PDFPrintModalOpen) {
                    cssClass = page['checked'] ? 'nschbc-show-section' : 'hide-on-print'
                } else {
                    cssClass = activeTab === codeDetails[0] ? 'nschbc-show-section' : 'hide-section'
                }
                return (
                    <div id={`${codeDetails[0]}-report`} className={cssClass}>
                        <IndustryDoctorsPNL
                            commonKey={'revenue'}
                            naicsCode={codeDetails[0]}
                            naicsName={codeDetails[1]}
                            page={'money'}
                            pageNumber={pageNumber}
                            report={'nschbc-employee-data'}
                            sheet={'pnl'}
                            title={'Doctor P&L'}
                            filters={state.filters}
                            year={state.filters.year}
                            yearRange={[state.filters.year]}
                        />
                    </div>
                )
            } else {
                <div id={`${codeDetails[0]}-report`} className={activeTab === codeDetails[0] ? 'nschbc-show-section' : 'hide-section'}>
                    No Aggregate Data Available for this NAICS
                </div>
            }
        })
    }

    const buildReportTabs = () => {
        const naicsCodes = props.filter_options.code.filter(codeDetails => codeDetails[0].length >= 6)
        const dataAvailable = Object.keys(state.calcs)
        
        return (
            <ul>
                <li key={`cover-page-tab`} className={`money report-link`} title={'Cover Page'} role='presentation' onClick={() => handleActiveTab('cover-page')}>
                    <a className={activeTab === 'cover-page' ? 'active' : ''} style={{ 'color': '#000000', 'fontWeight': 'bold', 'minWidth': '101px' }}>Cover Page</a>
                </li>
                <li key={`tab-of-contents-tab`} className={`money report-link`} title={'Table of Contents'} role='presentation' onClick={() => handleActiveTab('table-of-contents')}>
                    <a className={activeTab === 'table-of-contents' ? 'active' : ''} style={{ 'color': '#000000', 'fontWeight': 'bold', 'minWidth': '140px' }}>Table of Contents</a>
                </li>
                <li key={`intro-tab`} className={`money report-link`} title={'Introduction'} role='presentation' onClick={() => handleActiveTab('introduction')}>
                    <a className={activeTab === 'introduction' ? 'active' : ''} style={{ 'color': '#000000', 'fontWeight': 'bold' }}>Introduction</a>
                </li>
                {
                    naicsCodes.map(codeDetails => {
                        let styleNAICS = { 'color': '#8d8d8d' }
                        if (dataAvailable.includes(codeDetails[0]) && state.calcs[codeDetails[0]]['number_of_companies'] >= companyNumberView) {
                            styleNAICS = { 'color': '#000000', 'fontWeight': 'bold' }
                        }

                        return (
                            <li key={`${codeDetails[0]}-tab`} className={`money report-link`} title={codeDetails[1]} role='presentation' onClick={() => handleActiveTab(codeDetails[0])}>
                                <a className={activeTab === codeDetails[0] ? 'active' : ''} style={styleNAICS}>{codeDetails[0]}</a>
                            </li>
                        )
                    })
                }
            </ul>
        )
    }

    const coverPage = () => {
        let cssClass = ''
        if (PDFPrintModalOpen) {
            cssClass = displayPages[0]['checked'] ? 'nschbc-show-section' : 'hide-on-print'
        } else {
            cssClass = activeTab === 'cover-page' ? 'nschbc-show-section' : 'hide-section'
        }
        return (
            <div id='nschbc-cover-page-image' className={cssClass}>
                <img className='nschbc-cover-page-img' src={nschbcCoverImage} alt="Peerview Data NSCHBC cover page" />
            </div>
        )
    }

    const buildTextEditorTableOfContents = () => {
        let cssClass = ''
        if (PDFPrintModalOpen) {
            cssClass = displayPages[1]['checked'] ? 'nschbc-show-section' : 'hide-on-print'
        } else {
            cssClass = activeTab === 'table-of-contents' ? 'nschbc-show-section' : 'hide-section'
        }

        if (PDFPrintModalOpen) {
            return (
                <div id='text-editor-table-pdf' className={cssClass}>
                    <TextEditorPDF
                        key={'text-editor-table-pdf'}
                        companyNotes={tableOfContentNotes}
                        pdfStyle={'text-editor-pdf-page'}
                    />
                </div>
            )
        } else {
            return (
                <div id='text-editor-table' className={cssClass}>
                    <TextEditor
                        key={'text-editor-table'}
                        companyNotes={tableOfContentNotes}
                        onChangeNotes={onChangeTableNotes}
                    />
                </div>
            )
        }  
    }

    const buildTextEditorIntro = () => {
        let cssClass = ''
        if (PDFPrintModalOpen) {
            cssClass = displayPages[2]['checked'] ? 'nschbc-show-section' : 'hide-on-print'
        } else {
            cssClass = activeTab === 'introduction' ? 'nschbc-show-section' : 'hide-section'
        }

        if (PDFPrintModalOpen) {
            return (
                <div id='text-editor-intro-pdf' className={cssClass}>
                    <TextEditorPDF
                        key={'text-editor-intro-pdf'}
                        companyNotes={introNotes}
                        pdfStyle={'text-editor-pdf-page'}
                    />
                </div>
            )
        } else {
            return (
                <div id='text-editor-intro' className={cssClass}>
                    <TextEditor
                        key={'text-editor-intro'}
                        companyNotes={introNotes}
                        onChangeNotes={onChangeIntroNotes}
                    />
                </div>
            )
        }
    }

    const buildSummaryData = () => {
        const summaryByNaics = {};
        const targetYear = parseInt(state.filters.year, 10);

        companyData.forEach(company => {
            if (!summaryByNaics[company.naics]) {
                summaryByNaics[company.naics] = {
                    naics: company.naics,
                    naics_description: company.naics_description,
                    total_data_through_year: 0,
                    total_qualified: 0,
                    total_fte_survey_taken: 0,
                };
            }

            const row = summaryByNaics[company.naics];

            if (company.data_through_year) {
                row.total_data_through_year += 1;
            }

            if (company.qualified) {
                row.total_qualified += 1;
            }

            if (company.fte_survey_completed == state.filters.year) {
                row.total_fte_survey_taken += 1;
            }
        });

        return summaryByNaics;
    };

    const renderSummarySection = () => {
        const summaryData = buildSummaryData();

        return (
            <div className='nschbc-summary-section'>
                <table style={{ borderCollapse: 'collapse', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', margin: 'auto' }}>
                    <thead>
                        <tr style={{ backgroundColor: '#f0f0f0', borderBottom: '2px solid #333' }}>
                            <th style={{ textAlign: 'left', padding: '1px 2px', border: '1px solid #ddd' }}>NAICS</th>
                            <th style={{ textAlign: 'left', padding: '1px 2px', border: '1px solid #ddd' }}>Description</th>
                            <th style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>{tbLabel}</th>
                            <th style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>Qualified?</th>
                            <th style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>{fteLabel}</th>
                            <th style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>Report Ready?</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.keys(summaryData).sort().map((naicsCode, index) => {
                            const naicData = summaryData[naicsCode];
                            const meetsThreshold = naicData.total_data_through_year >= 10 && naicData.total_qualified >= 10 && naicData.total_fte_survey_taken >= 10;

                            return (
                                <tr key={`naics-summary-${index}`} style={{ backgroundColor: index % 2 === 0 ? '#fafafa' : 'white' }}>
                                    <td style={{ padding: '1px 2px', border: '1px solid #ddd', fontWeight: 'bold' }}>{naicData.naics}</td>
                                    <td style={{ padding: '1px 2px', border: '1px solid #ddd', fontSize: '13px' }}>{naicData.naics_description}</td>
                                    <td style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>{naicData.total_data_through_year}</td>
                                    <td style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>{naicData.total_qualified}</td>
                                    <td style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>{naicData.total_fte_survey_taken}</td>
                                    <td style={{ textAlign: 'center', padding: '1px 2px', border: '1px solid #ddd', width: '97px' }}>{meetsThreshold ? <div className='good-check'><CheckMark /></div> : <div className='bad-x'><XMark /></div>}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        );
    };

    const handleCompanyNumberView = (num) => {
        const startingPages = [
            {
                title: 'Cover Page',
                checked: true,
                pageNumber: 1
            },
            {
                title: 'Table of Contents',
                checked: true,
                pageNumber: 2
            },
            {
                title: 'Introduction',
                checked: true,
                pageNumber: 3
            }
        ]
        setCompanyNumberView(num)
        setDisplayPages((prevState => {
            const dataAvailable = Object.keys(state.calcs)
            let pdfData = []
            let pageNum = startingPageNumber;
            naicsCodes.forEach((codeDetails, i) => {
                if (dataAvailable.includes(codeDetails[0]) && state.calcs[codeDetails[0]]['number_of_companies'] >= num) {
                    pdfData.push({
                        title: codeDetails[0],
                        checked: true,
                        pageNumber: pageNum
                    })
                    pageNum += 1
                }
            })
            return [ ...startingPages, ...pdfData ]
        }))
    }

    const button10View = companyNumberView == 10 ? { 'fontWeight': 'bold', color: 'black', background: '#9fcc87', border: '1px solid' } : { 'fontWeight': 'normal' };
    const buttonAllView = companyNumberView == 1 ? { 'fontWeight': 'bold', color: 'black', background: '#9fcc87', border: '1px solid' } : { 'fontWeight': 'normal' };

    const getMuiTheme = createTheme({
        components: {
            MUIDataTable: {
                styleOverrides: {
                    paper: { width: '100%' },
                    tableRoot: {
                        width: '100%',
                        tableLayout: 'fixed', // 'fixed' forces equal widths, 'auto' sizes by content
                    },
                },
            },
            MUIDataTableToolbar: {
                styleOverrides: {
                    root: {
                    width: '100%',
                    },
                },
            },
        MuiTablePagination: {
            styleOverrides: {
            root: {
                '&:last-child': {
                paddingRight: '20px',
                }
            },
            selectLabel: {
                fontSize: '12px',
                margin: 0
            },
            displayedRows: {
                fontSize: '12px',
                margin: 0
            }
            }
        },
        MuiPaper: {
            styleOverrides: {
            root: {
                boxShadow: 'none !important',
                display: 'flex',
                flexDirection: 'column-reverse',
                paddingLeft: '10px'
            }
            }
        },
        MuiTable: {
            styleOverrides: {
            root: {
                order: 2
            }
            }
        },
        MUIDataTableToolbarSelect: {
            styleOverrides: {
            root: {
                display: 'none'
            }
            }
        },
        MuiToolbar: {
            styleOverrides: {
            root: {
                fontSize: '12px',
                order: 1
            }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
            root: {
                fontSize: '25px',
            }
            }
        },
        MuiFormControl: {
            styleOverrides: {
            root: {
                margin: '20px'
            }
            }
        },
        MUIDataTableResize: {
            styleOverrides: {
            root: {
                zIndex: 0,
            }
            }
        },
        MUIDataTableHeadCell: {
            styleOverrides: {
                root: {
                    // Distributes header cells evenly
                    width: 'auto',
                    whiteSpace: 'nowrap',
                },
                contentWrapper: {
                    justifyContent: 'center',
                    whiteSpace: 'nowrap',
                },
                data: {
                    fontSize: '12px',
                    paddingBottom: 0,
                    textTransform: 'none'
                },
                fixedHeader: {
                    zIndex: 0,
                    width: 'auto',
                },
                toolButton: {
                    padding: 'none',
                    justifyContent: 'center'
                },
                tooltip: {
                    fontSize: '14px',
                }
            }
        },
        MUIDataTableSelectCell: {
            styleOverrides: {
            headerCell: {
                zIndex: 1,
            },
            fixedLeft: {
                zIndex: 0,
            }
            }
        },
        MuiTableCell: {
            styleOverrides: {
            head: {
                zIndex: 1,
            },
            root: {
                display: 'table-cell',  // was 'flex'
                borderBottom: 'none',
                borderRight: '1px solid #e0e0e0',
                fontSize: '12px',
                padding: '1px 2px',
                textAlign: 'center',
                verticalAlign: 'middle',
            },
            }
        },
        MuiCheckbox: {
            styleOverrides: {
            root: {
                padding: '3px',
                maxWidth: '100px'
            }
            }
        },
        MUIDataTableBodyCell: {
            styleOverrides: {
                root: {
                    width: 'auto',
                    zIndex: 0,
                    fontSize: '13px',
                    minHeight: '20px',
                    padding: '0 3px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                }
            }
        },
        MuiTableHead: {
            styleOverrides: {
                head: {
                    display: 'flex'
                },
                root: {
                    position: 'sticky',
                    top: '0px',
                    background: 'white',
                    zIndex: '2'
                }
            }
        },
        MuiTableRow: {
            styleOverrides: {
                head: {
                    display: 'flex',
                    borderTop: '1px solid #e0e0e0',
                    borderBottom: '1px solid #e0e0e0'
                },
                root: {
                    display: 'flex',
                    '&:nth-child(even)': {
                        backgroundColor: '#F5F5F5',
                    },
                    '&:hover': {
                        backgroundColor: '#BFE0AE',
                    },
                },
                footer: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    borderBottom: '1px solid #e0e0e0'
                }
            }
        },
        MuiTypography: {
            styleOverrides: {
            root: {
                fontSize: '12px',
            },
            body1: {
                fontSize: '16px',
            },
            body2: {
                fontSize: '12px',
            }
            }
        },
        MuiFormLabel: {
            styleOverrides: {
            root: {
                fontSize: '1.2em'
            }
            }
        },
        MuiInput: {
            styleOverrides: {
            root: {
                fontSize: '0.95em'
            }
            }
        },
        MuiMenuItem: {
            styleOverrides: {
            root: {
                fontSize: '1.1em'
            }
            }
        },
        MuiButton: {
            styleOverrides: {
            root: {
                fontSize: '0.9em'
            }
            }
        },
        MuiChip: {
            styleOverrides: {
            root: {
                fontSize: '1em'
            }
            }
        }
        }
    });

    const handleResize = (index, newSize) => {
        const newWidths = { ...columnWidths };
        newWidths[index] = newSize;
        setColumnWidths(newWidths);
    };

    const handleUserTableResize = (index, newSize) => {
        const newWidths = { ...userColumnWidths };
        newWidths[index] = newSize;
        setUserColumnWidths(newWidths);
    };

    const dataProps = companyData;
    const userProps = userData;

    const handleAllSort = (name = 'name', table = 'aSortOrder') => {
        let newDirection = 'none'

        const tableState = table === 'aSortOrder' ? aSortOrder : uSortOrder

        if (name !== tableState.name || tableState.direction === 'none' || (name === 'name' && tableState.direction === 'desc')) {
            newDirection = 'asc'
        } else if (name === tableState.name && tableState.direction === 'asc') {
            newDirection = 'desc'
        } else if (name === tableState.name && tableState.direction === 'desc') {
            newDirection = 'none'
        }

        let sortOrder = {
            name: name,
            direction: newDirection
        }

        if (table === 'aSortOrder') {
            setASortOrder(sortOrder)
        } else {
            setUSortOrder(sortOrder)
        }
    }

    const allClientColumns = [
        // column 0
        {
            name: 'firm',
            label: 'Firm',
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-firm'
                            width={columnWidths.firm}
                            height={25}
                            onResize={(e, { size }) => handleResize("firm", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.firm }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('firm', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'firm' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'firm' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.firm }
                }),
            },
        },
        // column 1
        {
            name: 'name',
            label: 'Client ID',
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-name'
                            width={columnWidths.name}
                            height={25}
                            onResize={(e, { size }) => handleResize("name", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.name }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('name', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'name' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'name' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.name }
                }),
            },
        },
         // column 2
        {
            name: 'naics',
            label: 'NAICS',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-naics'
                            width={columnWidths.naics}
                            height={25}
                            onResize={(e, { size }) => handleResize("naics", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.naics }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('naics', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'naics' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'naics' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.naics }
                }),
                customBodyRender: (value) => {
                    return (
                        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {value}
                        </div>
                    );
                },
            },
        },
         // column 3
        {
            name: 'naics_description',
            label: 'Description',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-naics_description'
                            width={columnWidths.naics_description}
                            height={25}
                            onResize={(e, { size }) => handleResize("naics_description", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.naics_description }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('naics_description', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'naics_description' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'naics_description' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.naics_description }
                }),
            },
        },
         // column 4
        {
            name: 'data_through_year',
            label: tbLabel,
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-data_through_year'
                            width={columnWidths.data_through_year}
                            height={25}
                            onResize={(e, { size }) => handleResize("data_through_year", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.data_through_year }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('data_through_year', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'data_through_year' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'data_through_year' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.data_through_year }
                }),
                customBodyRender: (value) => {
                    return value ? <div className='good-check'><CheckMark /></div> : <div className='bad-x'><XMark /></div>
                },
            },
        },
         // column 5
        {
            name: 'qualified',
            label: 'Qualified?',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-qualified'
                            width={columnWidths.qualified}
                            height={25}
                            onResize={(e, { size }) => handleResize("qualified", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.qualified }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('qualified', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'qualified' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'qualified' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.qualified }
                }),
                customBodyRender: (value) => {
                    return value ? <div className='good-check'><CheckMark /></div> : <div className='bad-x'><XMark /></div>
                }
            },
        },
         // column 6
        {
            name: 'fte_survey_completed',
            label: fteLabel,
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-fte_survey_completed'
                            width={columnWidths.fte_survey_completed}
                            height={25}
                            onResize={(e, { size }) => handleResize("fte_survey_completed", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.fte_survey_completed }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('fte_survey_completed', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'fte_survey_completed' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'fte_survey_completed' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.fte_survey_completed }
                }),
                customBodyRender: (value) => {
                    return value == state?.filters?.year ? <div className='good-check'><CheckMark /></div> : <div className='bad-x'><XMark /></div>
                },
            },
        },
         // column 7
        {
            name: 'owners',
            label: 'Owners',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-owners'
                            width={columnWidths.owners}
                            height={25}
                            onResize={(e, { size }) => handleResize("owners", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.owners }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('owners', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'owners' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'owners' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.owners }
                }),
            },
        },
         // column 8
        {
            name: 'number_of_associates',
            label: 'Associates',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-number_of_associates'
                            width={columnWidths.number_of_associates}
                            height={25}
                            onResize={(e, { size }) => handleResize("number_of_associates", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.number_of_associates }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('number_of_associates', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'number_of_associates' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'number_of_associates' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.number_of_associates }
                }),
            },
        },
         // column 9
        {
            name: 'hygienists_or_nurses',
            label: 'Hygenists / Nurses',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-hygienists_or_nurses'
                            width={columnWidths.hygienists_or_nurses}
                            height={25}
                            onResize={(e, { size }) => handleResize("hygienists_or_nurses", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.hygienists_or_nurses }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('hygienists_or_nurses', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'hygienists_or_nurses' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'hygienists_or_nurses' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.hygienists_or_nurses }
                }),
            },
        },
         // column 10
        {
            name: 'number_of_assistants',
            label: 'Assistants',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-number_of_assistants'
                            width={columnWidths.number_of_assistants}
                            height={25}
                            onResize={(e, { size }) => handleResize("number_of_assistants", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.number_of_assistants }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('number_of_assistants', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'number_of_assistants' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'number_of_assistants' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.number_of_assistants }
                }),
            },
        },
         // column 11
        {
            name: 'number_of_office_employees',
            label: 'Office Employees',
            options: {
                filter: false,
                sort: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-number_of_office_employees'
                            width={columnWidths.number_of_office_employees}
                            height={25}
                            onResize={(e, { size }) => handleResize("number_of_office_employees", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: columnWidths.number_of_office_employees }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('number_of_office_employees', 'aSortOrder')}
                            >{column.label}</div>
                            {aSortOrder.name === 'number_of_office_employees' && aSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {aSortOrder.name === 'number_of_office_employees' && aSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: columnWidths.number_of_office_employees }
                }),
            },
        },
    ];

    const userColumns = [
        // column 0
        {
            name: 'firm',
            label: 'Firm',
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-ufirm'
                            width={userColumnWidths.firm}
                            height={25}
                            onResize={(e, { size }) => handleUserTableResize("firm", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: userColumnWidths.firm }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('firm', 'uSortOrder')}
                            >{column.label}</div>
                            {uSortOrder.name === 'firm' && uSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {uSortOrder.name === 'firm' && uSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: userColumnWidths.firm }
                }),
            },
        },
        {
            name: 'first_name',
            label: 'First Name',
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-first_name'
                            width={userColumnWidths.first_name}
                            height={25}
                            onResize={(e, { size }) => handleUserTableResize("first_name", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: userColumnWidths.first_name }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('first_name', 'uSortOrder')}
                            >{column.label}</div>
                            {uSortOrder.name === 'first_name' && uSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {uSortOrder.name === 'first_name' && uSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: userColumnWidths.first_name }
                }),
            },
        },
        {
            name: 'last_name',
            label: 'Last Name',
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-last_name'
                            width={userColumnWidths.last_name}
                            height={25}
                            onResize={(e, { size }) => handleUserTableResize("last_name", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: userColumnWidths.last_name }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('last_name', 'uSortOrder')}
                            >{column.label}</div>
                            {uSortOrder.name === 'last_name' && uSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {uSortOrder.name === 'last_name' && uSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: userColumnWidths.last_name }
                }),
            },
        },
        {
            name: 'email',
            label: 'Email',
            options: {
                filter: false,
                sort: true,
                sortThirdClickReset: true,
                customHeadRender: ({ index, ...column }) => {
                    return (
                        <Resizable
                            key='nschbc-email'
                            width={userColumnWidths.email}
                            height={25}
                            onResize={(e, { size }) => handleUserTableResize("email", size.width)}
                        >
                        <th
                            style={{ fontSize: '12px', fontWeight: 'normal', textAlign: 'center', width: userColumnWidths.email }}
                        >
                            <div
                                style={{ cursor: "pointer", fontWeight: 'bold' }}
                                onClick={() => handleAllSort('email', 'uSortOrder')}
                            >{column.label}</div>
                            {uSortOrder.name === 'email' && uSortOrder.direction === "asc" && <ArrowUpward fontSize="small" />}
                            {uSortOrder.name === 'email' && uSortOrder.direction === "desc" && <ArrowDownward fontSize="small" />}
                        </th>
                        </Resizable>
                    );
                },
                setCellProps: () => ({
                    style: { width: userColumnWidths.email }
                }),
            },
        },
    ];

    const numericDescColumns = displaySection === 'table' ? [4, 5, 6, 7, 8, 9, 10, 11] : [];

    const allOptions = {
        textLabels: {
            body: {
                noMatch: isLoading
                    ? <LoaderGraphic logoLoader={true} />
                    : 'Sorry, no matching records found.',
            },
        },
        searchDelay: 300,
        searchOpen: true,
        selectableRows: 'none',
        resizableColumns: true,
        responsive: 'standard',
        print: false,
        download: false,
        filter: false,
        rowsPerPage: 100,
        rowsPerPageOptions: [25, 50, 100],
        page: 0,
        confirmFilters: true,
        searchPlaceholder: displaySection === 'table' ? 'Search by Firm / Client ID / NAICS' : 'Search',
        customSort: (data, colIndex, order) => {
            return data.sort((a, b) => {
                const valA = a.data[colIndex];
                const valB = b.data[colIndex];

                const emptyA = valA === null || valA === undefined || valA === '';
                const emptyB = valB === null || valB === undefined || valB === '';

                // Push empty values to the bottom regardless of sort direction
                if (emptyA && emptyB) return 0;
                if (emptyA) return 1;
                if (emptyB) return -1;

                // Invert the order for numeric columns
                const effectiveOrder = numericDescColumns.includes(colIndex)
                    ? order === 'asc' ? 'desc' : 'asc'
                    : order;

                // Normal comparison for non-empty values
                if (effectiveOrder === 'asc') {
                    return valA < valB ? -1 : valA > valB ? 1 : 0;
                }
                return valA > valB ? -1 : valA < valB ? 1 : 0;
            });
        },
    };

    const allClientOptions = {
        ...allOptions,
        sortOrder: aSortOrder,
        onTableChange: (action, tableState) => {
            if (action === 'sort' && tableState.sortOrder?.name) {
                setASortOrder(tableState.sortOrder);
            }
    
            // your existing search/filter logic...
            if (['search', 'sort', 'filterChange', 'resetFilters'].includes(action)) {
                if (displaySection === 'table') {
                    setFilteredData(
                        tableState.displayData.map(row => {
                            return allClientColumns.reduce((obj, col, i) => {
                                obj[col.name] = row.data[i] ?? '';
                                return obj;
                            }, {});
                        })
                    );
                }
            }
        },
    };

    const userOptions = {
        ...allOptions,
        sortOrder: uSortOrder,
        onTableChange: (action, tableState) => {
            if (action === 'sort' && tableState.sortOrder?.name) {
                setUSortOrder(tableState.sortOrder);
            }
        },
    };

    const LoadingOverlay = () => {
        return (
            <div className='client-overlay'>
                <LoaderGraphic logoLoader={true} />
            </div>
        );
    };
    
    return (
        <div id='admin-nschbc-reports'>
            <div id='sticky-topnav-left-btns'>
                <IndustryPDFandPrint
                    page={'nschbc-employee-data'}
                    planAccess={{
                        export_to_excel: false,
                        print_and_pdf: true,
                    }}
                    componentRefs={reportRefs}
                    displayPages={displayPages}
                    PDFPrintModalOpen={PDFPrintModalOpen}
                    setPDFPrintModalOpen={setPDFPrintModalOpen}
                    handlePDFandPrintChecked={handlePDFandPrintChecked}
                    xlsx={false}
                    year={props.year}
                    yearRange={[props.year]}
                />
                <ExportDropdown
                    allClientColumns={allClientColumns}
                    printOnlyVisibleData={filteredData}
                    planAccess={{}}
                    page={'nschbc'}
                    xlsx={true}
                />
            </div>
            <Modal
                className={{
                    base: 'client-modal-content',
                    afterOpen: 'client-modal-content_after-open',
                    beforeClose: 'client-modal-content_before-close',
                }}
                overlayClassName={{
                    base: 'overlay-base',
                    afterOpen: 'overlay-base_after-open',
                    beforeClose: 'overlay-base_before-close',
                }}
                isOpen={filtersModalIsOpen}
                onRequestClose={closeFiltersModal}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={0}
                contentLabel='NSCHBC Employee Report Filters Modal'
            >
                <div>
                    <header className='company-modal-header'>
                    <h1 className='client-company-name'>Report Filters</h1>
                    </header>
                    <div className='report-filters-container'>
                    <div className='client-info-div'>
                        <p>621s NSCHBC Companies with Employee Data. DataType: Private</p>
                    </div>
                    <DropdownFilter
                        calendarYearEnd={true}
                        clas={'money-dropdown-filters'}
                        report={'nschbc-employee-data'}
                        current={state.filters}
                        options={state.filterOptions}
                        onClick={handleFilterSubmit}
                    />
                    </div>
                </div>
            </Modal>

            <div id='sticky-side-btns'>
                <span
                    className='filters-btn-span hide-on-print'
                    onMouseEnter={() => handleMouseEnter('filters')}
                    onMouseLeave={() => handleMouseLeave('leave')}
                >
                    <button className='filters-btn'><FontAwesomeIcon icon={faAnglesLeft} onClick={() => openFiltersModal()} /></button>
                    {activePopover === 'filters' && (
                    <div className='filters-popover'>
                        Display Filters
                    </div>)}
                </span>
            </div>
            <div className='nschbc-page-header'>
                <h1>NSCHBC Reports</h1>
                <button className={displaySection === 'summary' ? '' : 'normal'} onClick={() => setDisplaySection('summary')}>NAICS Totals</button>
                <button className={displaySection === 'table' ? '' : 'normal'} onClick={() => setDisplaySection('table')}>Client Table</button>
                <button className={displaySection === 'reports' ? '' : 'normal'} onClick={() => setDisplaySection('reports')}>Reports</button>
                <button className={displaySection === 'users' ? '' : 'normal'} onClick={() => setDisplaySection('users')}>Users</button>
            </div>
            <div style={{ display: displaySection == 'summary' ? 'block' : 'none' }}>
                {isLoading ? <LoadingOverlay /> : renderSummarySection()}
            </div>
            <div style={{ display: displaySection == 'table' ? 'block' : 'none' }}>
                {isLoading ? <LoadingOverlay /> : null}
                <ThemeProvider theme={getMuiTheme}>
                    <MUIDataTable
                        data={dataProps}
                        columns={allClientColumns}
                        options={allClientOptions}
                    />
                </ThemeProvider>
            </div>
            <div style={{ display: displaySection == 'reports' ? 'block' : 'none' }}>
                <div style={{ 'display': 'flex', 'justifyContent': 'space-between', 'alignItems': 'center', 'width': '80%', 'margin': 'auto', 'padding': '10px' }}>
                    <button onClick={(e) => handleCompanyNumberView(10)} style={button10View}>10 Plus Numbers View</button>
                    <button onClick={(e) => handleCompanyNumberView(1)} style={buttonAllView}>All Numbers View</button>
                    <button onClick={(e) => calculateNSCHBCEmployeeAggData(e)}>Calculate NSCHBC Employee Aggregate Data</button>
                </div>

                <div className='nschbc-report-tabs'>
                    {buildReportTabs()}
                </div>

                <div>
                    <Data.Provider value={{ calcs: state.calcs }} >
                        <div ref={reportRefs} className='nschbc-doc-pnl-container'>
                            {coverPage()}
                            {buildTextEditorTableOfContents()}
                            {buildTextEditorIntro()}
                            {isLoading ? <LoaderGraphic logoLoader={true} /> : buildDocPNLs()}
                        </div>
                    </Data.Provider>
                </div>
            </div>
            <div style={{ display: displaySection == 'users' ? 'block' : 'none' }}>
                {isLoading ? <LoadingOverlay /> : null}
                <ThemeProvider theme={getMuiTheme}>
                    <MUIDataTable
                        data={userProps}
                        columns={userColumns}
                        options={userOptions}
                    />
                </ThemeProvider>
            </div>
        </div>
    )
}

export default NSCHBCReportContainer;